export const emailValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
